import React from "react";
import usePassPromo from "../../hook/usePassPromo";
import lockIcon from "../../icons/pass-badge-lock.svg";
import sparkIcon from "../../icons/pass-promo-spark.svg";
import PassPromoDateCard from "./PassPromoDateCard";
import { usePassText } from "./passI18n";
import { formatPromoDayLabel, formatPromoMonthLabel } from "./passPromoFormat";
import "./PassPromo.css";

const ILLUSTRATION_SCALE = 1.2266;

export default function PassPromoCard({ enabled, productCode, offerEndDate }) {
  const translate = usePassText();
  const { state, highlightedDate } = usePassPromo({ enabled, productCode, offerEndDate });

  if (!state || !highlightedDate) return null;

  return (
    <div className="dp-promo-card-wrap">
      <div className="dp-promo dp-promo-card">
        <span className="dp-promo-card-blob" aria-hidden="true" />
        <p className="dp-promo-card-title">{translate("DOTORE_PASS.PROMO.BEFORE.TITLE")}</p>
        <div className="dp-promo-illus" aria-hidden="true">
          <span className="dp-promo-pill dp-promo-illus-class">
            {translate("DOTORE_PASS.PROMO.CLASS")}
          </span>
          <span className="dp-promo-pill dp-promo-illus-free">
            {translate("DOTORE_PASS.PROMO.FREE")}
          </span>
          <PassPromoDateCard
            month={formatPromoMonthLabel(highlightedDate)}
            day={formatPromoDayLabel(highlightedDate)}
            scale={ILLUSTRATION_SCALE}
          />
          <img className="dp-promo-illus-spark" src={sparkIcon} alt="" />
          <img className="dp-promo-illus-lock" src={lockIcon} alt="" />
        </div>
      </div>
    </div>
  );
}
